import { JsonView, defaultStyles } from 'react-json-view-lite';
import { useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";

const ViewMetadataPopup = ({ diffData }) => {
  const [showPopup, setShowPopup] = useState(false);


  const closePopup = () => {
    setShowPopup(false);
  }

  return (
    <>
      <Button
        onClick={() => setShowPopup(true)}
      >
        View
      </Button>
      <Modal
        show={showPopup}
        onHide={closePopup}
        backdrop="static"
        keyboard={false}
        centered
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Log Metadata</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col lg="12">
              <JsonView
                data={diffData}
                shouldExpandNode={(level) => level < 2 ? true : false}
                style={defaultStyles}
                clickToExpandNode={true}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={closePopup}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ViewMetadataPopup;
